import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotificationsFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M896 -144Q837 -144 794.5 -101.5Q752 -59 752 0Q752 16 736.0 16.0Q720 16 720 0Q720 -73 771.5 -124.5Q823 -176 896 -176Q912 -176 912.0 -160.0Q912 -144 896 -144ZM1728 128Q1728 76 1690.0 38.0Q1652 0 1600 0H1152Q1152 -106 1077.0 -181.0Q1002 -256 896.0 -256.0Q790 -256 715.0 -181.0Q640 -106 640 0H192Q140 0 102.0 38.0Q64 76 64 128Q114 170 155.0 216.0Q196 262 240.0 335.5Q284 409 314.5 494.0Q345 579 364.5 700.0Q384 821 384 960Q384 1112 501.0 1242.5Q618 1373 808 1401Q800 1420 800 1440Q800 1480 828.0 1508.0Q856 1536 896.0 1536.0Q936 1536 964.0 1508.0Q992 1480 992 1440Q992 1420 984 1401Q1174 1373 1291.0 1242.5Q1408 1112 1408 960Q1408 821 1427.5 700.0Q1447 579 1477.5 494.0Q1508 409 1552.0 335.5Q1596 262 1637.0 216.0Q1678 170 1728 128Z"
	})
});
export default SvgNotificationsFill;
